<template>
  <div class="text-center full-width-login">
    <div class="fixed-top m-logo">
      <img src="../assets/mxd-white.svg" style="width: 10%" alt="MXD Logo" />
    </div>

    <div v-if="!passwordReset">
      <div class="form-signin">
        <h3 class="h3 mb-3 header font-weight-normal">Forgot Password?</h3>
        <p class="info-text header-text">Enter your email address.</p>
        <label for="username" class="sr-only">Email Address</label>
        <input
          type="email"
          id="username"
          v-model="username"
          class="input-control"
          placeholder="email address"
          required
          autofocus
        />
        <div v-if="!usernameFound" class="alert alert-danger">
          Email Address not Found.
        </div>

        <button
          class="base-button w-100 mt-3"
          type="submit"
          @click="handleSubmit"
        >
          Reset Password
        </button>
        <div class="mt-4">
          <router-link
            :to="{ name: 'login' }"
            class="mxd-blue-text mr-3 info-text"
            >Login</router-link
          >
          <router-link
            :to="{ name: 'create-account' }"
            class="mxd-blue-text ml-3 info-text"
            >Create Account
          </router-link>
        </div>
      </div>
    </div>
    <h3 class="mt-4" v-else>
      The password reset request was sent. <br />Please check your email for
      final steps.
    </h3>
  </div>
</template>

<script>
export default {
  data() {
    return {
      username: "",
      password: "",
      usernameFound: true,
      passwordReset: false,
    };
  },
  methods: {
    handleSubmit() {
      let t = this;
      if (this.username.length > 0) {
        this.$store
          .dispatch("apiEvents/forgotPassword", {
            username: this.username,
          })
          .then((response) => {
            if (response.status == 200) {
              t.usernameFound = true;
              t.passwordReset = true;
            }
          })
          .catch(function (error) {
            if (error.response.status == 500) {
              t.usernameFound = false;
            }
          });
      }
    },
  },
};
</script>

<style scoped>
.full-width-login {
  width: 100%;
  display: -ms-flexbox;
  display: -webkit-box;
  display: flex;
  -ms-flex-align: center;
  -ms-flex-pack: center;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  padding-top: 140px;
  padding-bottom: 40px;
}

.mxd-blue-text {
  color: #fff;
}

.mxd-blue-text:hover,
.header-text {
  color: #80ffee;
}

.mxd-blue {
  background-color: #80ffee;
  color: #000;
}

.mxd-blue-text:hover {
  text-decoration: none;
}

.form-signin {
  width: 100%;
  max-width: 350px;
  padding: 15px;
  margin: 0 auto;
  min-width: 325px;
}

.form-signin .form-control {
  position: relative;
  box-sizing: border-box;
  height: auto;
  padding: 10px;
  font-size: 16px;
  width: 100%;
  border-radius: 2px;
}

.form-signin .form-control:focus {
  z-index: 2;
}
</style>
